module.exports = __webpack_public_path__ + "img/bank_16.e464eef6.png";